import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

import { Container } from 'js/components/Grid'
import HideVisually from 'js/components/HideVisually/HideVisually'

import styles from './PreHeader.module.css'

const PreHeader = ({ site }) => {
    const { t } = useTranslation()

    if (!site) {
        return null
    }

    return (
        <div className={styles.wrapper}>
            <Container>
                {site.logo && (
                    <div className={styles.logo}>
                        <Link to="/">
                            <HideVisually>{t('global.home-page')}</HideVisually>
                            <img
                                src={site.logo}
                                alt={site.logoAlt ?? ''}
                                aria-hidden={!site.logoAlt}
                            />
                        </Link>
                    </div>
                )}
            </Container>
        </div>
    )
}

export default PreHeader
